"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UI_ORDER = exports.UI_FIELD = exports.UI_PLACEHOLDER = exports.WIDGET_TYPE_FILE_UPLOAD = exports.WIDGET_TYPE_LONG_TEXT = exports.WIDGET_TYPE_SHORT_TEXT = exports.BUILD_FORM_SCHEMA = void 0;
exports.BUILD_FORM_SCHEMA = 'BUILD_FORM_SCHEMA';
exports.WIDGET_TYPE_SHORT_TEXT = 'TextInput';
exports.WIDGET_TYPE_LONG_TEXT = 'TextArea';
exports.WIDGET_TYPE_FILE_UPLOAD = 'FileUploadField';
exports.UI_PLACEHOLDER = 'ui:placeholder';
exports.UI_FIELD = 'ui:field';
exports.UI_ORDER = 'ui:order';
//# sourceMappingURL=formWriter.js.map